import React, { useEffect } from "react";
import { motion } from "framer-motion";
import Navigation from "../Navigation/Navigation";
import HomeFooter from "../HomePage/HomeFooter";

const Rules = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const tournamentRules = [
    {
      id: 1,
      title: "Sustav i podloga",
      description:
        "Igra se 5+1 na betonskom igralištu. Ekipa može prijaviti maksimalno 12 igrača. Svaka prijava dodatnog igrača naplaćuje se 10 €. Posljednja prijava igrača moguća je do utakmice četvrtfinala. Igrači prijavljeni nakon toga nemaju pravo nastupa.",
    },
    {
      id: 2,
      title: "Vrijeme i lopta",
      description:
        "Trajanje utakmice grupne faze je 2 x 12 minuta. Utakmice playoffa igraju se 2 x 15 minuta. Igra se loptom br. 5 s utegom.",
    },
    {
      id: 3,
      title: "Golmanov posjed i prekidi",
      description:
        "Golman smije držati loptu u posjedu maksimalno 4 sekunde na svojoj polovici. Prekid sa strane mora se izvesti na aut-liniji ili iza nje u roku od 4 sekunde.",
    },
    {
      id: 4,
      title: "Akumulirani prekršaji",
      description:
        "Nakon petog akumuliranog prekršaja u poluvremenu, svaki sljedeći kažnjava se kaznenim udarcem s 10 metara.",
    },
    {
      id: 5,
      title: "Izmjene",
      description:
        "Izmjene su leteće i neograničene, ali se moraju obaviti u označenom prostoru kod centra.",
    },
    {
      id: 6,
      title: "Fair play",
      description:
        "Psovanje suca ili protivnika kažnjava se isključenjem igrača na 2 minute. Igrač s crvenim kartonom nema pravo nastupa u sljedećoj utakmici.",
    },
    {
      id: 7,
      title: "Bodovanje",
      description:
        "1. Broj bodova, 2. Međusobni omjer, 3. Gol-razlika, 4. Broj zabijenih golova",
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
      },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, ease: "easeOut" },
    },
  };

  return (
    <>
      <Navigation />
      <section className="rules-section">
        <motion.h2
          className="rules-title"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6 }}
        >
          Pravila Turnira
        </motion.h2>

        <motion.div
          className="rules-container"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          {tournamentRules.map((rule) => (
            <motion.div
              key={rule.id}
              className="rule-card"
              variants={cardVariants}
              whileHover={{ scale: 1.03, transition: { duration: 0.2 } }}
            >
              <div className="rule-number-circle">
                <span>{rule.id}</span>
              </div>
              <div className="rule-content">
                <h3>{rule.title}</h3>
                <p>{rule.description}</p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </section>
      <HomeFooter />
    </>
  );
};

export default Rules;
